import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { ReduxState } from '../../interfaces';
import { useLifecycle } from '../../hooks/useLifecycle';
import Datatable from '../../modules/datatable/datatable';
import RightPanel from '../shared/rightPanel';
import RightPanelSelector from '../shared/rightPanelSelector';
import ModalSelector from '../shared/modalSelector';
import { PanelsType, ModalsType } from '../../modules/dialogs/model';
import * as Customers from '../../modules/customers';
import DataTableSummary from '../shared/datatable/summary';
import Scrim from '../shared/scrim';

interface StateProps {
  customersState: Customers.State;
  activeDialog: PanelsType;
  activeModal: ModalsType;
}

type Props = StateProps;

const CustomersContent: React.FC<Props> = (props) => {
  useLifecycle('CustomersContent');

  useEffect(() => {
    props.customersState.pagesToLoad.forEach((pageIdx) => {
      Customers.searchPage(pageIdx);
    });
  }, [props.customersState.pagesToLoad]);

  return (
    <div className="layout__content__main" style={{ height: '100%' }}>
      <RightPanel
        isOpened={!!props.activeDialog}
        content={<RightPanelSelector activeDialog={props.activeDialog} />}
      >
        <DataTableSummary
          dtState={props.customersState}
          clearSelection={Customers.clearSelection}
          msgMain={Customers.keyTotalCustomers}
        />
        <Scrim
          isActive={props.customersState.table.isLoading}
          fullHeight
          hideSpinner
        >
          <div className="layout__content__table_wrapper">
            <div className="datatable__layout">
              <Datatable
                rows={props.customersState.table.content}
                getPK={props.customersState.selection.getPK}
                isLoading={false} // {props.customersState.table.isLoading}
                columns={props.customersState.table.columns}
                // getTrProps={getTrProps}
                isSelectable
                isMultiSelect={false}
                allSelected={props.customersState.selection.isAllSelected}
                onToggleItemSelection={Customers.updateTableItemSelection}
                isItemSelected={Customers.isTableItemSelected}
                onToggleAllSelected={Customers.updateTableSelectAll}
                pagination={props.customersState.table.pagination}
                onPageChange={Customers.changeTablePage}
                onPageSizeChange={Customers.changeTableSizePage}
                sortCriteria={props.customersState.sort}
                onSortCriteriaChanged={Customers.changeTableSorting}
              />
            </div>
          </div>
        </Scrim>
      </RightPanel>
      <ModalSelector activeModal={props.activeModal} />
    </div>
  );
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  customersState: state.customersState,
  activeDialog: state.dialogState.activeDialog,
  activeModal: state.dialogState.activeModal,
});

export default connect(mapStateToProps)(CustomersContent);
